<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h4>{{ "components.requestInBatch.updateInBatch" | translate }}</h4>
    </div>
  </div>

  <app-edit-request-template>
    <div column>{{ "components.editRequest.takeInCharge" | translate }}</div>
    <button button class="btnRound" (click)="updateInBatch(updateInBatchEnum.takeInCharge)">
      {{ "components.editRequest.choose" | translate }}
    </button>
  </app-edit-request-template>

  <app-edit-request-template>
    <div column>
      {{ "components.editRequest.cancelTakeInCharge" | translate }}
    </div>
    <button button class="btnRound" (click)="updateInBatch(updateInBatchEnum.cancelTakeInCharge)">
      {{ "components.editRequest.choose" | translate }}
    </button>
  </app-edit-request-template>

  <app-edit-request-template>
    <div column>{{ "components.editRequest.updateActivity" | translate }}</div>
    <button button class="btnRound" (click)="updateInBatch(updateInBatchEnum.updateActivity)">
      {{ "components.editRequest.choose" | translate }}
    </button>
  </app-edit-request-template>

  <app-edit-request-template>
    <div column>
      {{ "components.editRequest.updateResponsible" | translate }}
    </div>
    <button button class="btnRound" (click)="updateInBatch(updateInBatchEnum.updateResponsible)">
      {{ "components.editRequest.choose" | translate }}
    </button>
  </app-edit-request-template>

  <app-edit-request-template>
    <div column>
      {{ "components.editRequest.closeWorkorder" | translate }}
    </div>
    <button button class="btnRound" (click)="updateInBatch(updateInBatchEnum.closeWorkorder)">
      {{ "components.editRequest.choose" | translate }}
    </button>
  </app-edit-request-template>

  <hr class="separator" />
  <div class="row value center">
    <div class="col-sm-4 col-sm-offset-4">
      <button class="btnFilled" (click)="router.navigate(['list'])">
        <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
        {{ "components.editRequest.back" | translate }}
      </button>
    </div>
  </div>
</div>
